import { type ReactNode } from 'react';

interface CabecalhoPaginaProps {
  titulo: string;
  /** Uma frase sobre o que se faz aqui ou o contexto atual (escopo, período). */
  descricao?: ReactNode;
  acoes?: ReactNode;
}

export function CabecalhoPagina({ titulo, descricao, acoes }: CabecalhoPaginaProps) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div className="grid min-w-0 gap-1">
        <h1 className="text-2xl font-semibold tracking-tight text-balance">{titulo}</h1>
        {descricao && <p className="max-w-prose text-base text-texto-suave">{descricao}</p>}
      </div>
      {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
    </header>
  );
}
